import get from 'lodash/get';
import {createEventHandler} from 'recompose';
import 'rxjs/add/operator/last';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import {stateGoBack} from '../../app/actions';
import {getCollection, getId, getLinkId} from '../../core-utilities/domain/ReduxUtils';
import {
  ASSET_FILE_REQUIREMENT_COLLECTION,
  ASSET_FORM_REQUIREMENT_COLLECTION,
  FILE_REQUIREMENT_COLLECTION,
  FORM_REQUIREMENT_COLLECTION,
} from '../domain/config';


export function buildGoBack(config) {
  const {
    props$,
    requirement$,
    taskListState,
    taskDetailsState,
    dispatch,
  } = config;

  const {
    handler: onGoBack,
    stream: goBack$,
  } = createEventHandler();

  goBack$
    .withLatestFrom(requirement$)
    .takeUntil(props$.last())
    .subscribe(([_, requirement]) => {
      const taskId = getTaskId(requirement);
      if (!taskId) {
        dispatch(stateGoBack({state: taskListState}));
      } else {
        dispatch(stateGoBack({state: taskDetailsState, params: {taskId}}));
      }
    });

  return onGoBack;
}

function getTaskId(requirement) {
  switch (getCollection(requirement)) {
    case FILE_REQUIREMENT_COLLECTION:
    case FORM_REQUIREMENT_COLLECTION:
      return getLinkId(requirement, 'task');

    case ASSET_FILE_REQUIREMENT_COLLECTION:
    case ASSET_FORM_REQUIREMENT_COLLECTION:
      return getLinkId(requirement, 'assetTask');
  }
}

export function getFulfillmentFile(model) {
  return get(model, 'currentFileAsset.file');
}

export function getRequirementFileName(requirement, file) {
  if (file.name) {
    let extension = file.name.substr((~-file.name.lastIndexOf(".") >>> 0) + 2);
    extension = extension ? '.' + extension : '';
    return (requirement ? requirement.name : 'file') + extension;
  } else {
    return (requirement ? requirement.name : 'file');
  }
}

export function getIsOpeningFulfillment(openingFileId, model) {
  if (openingFileId === null) {
    return false;
  } else {
    const fileId = getId(getFulfillmentFile(model));
    return openingFileId === fileId;
  }
}

export function getIsOpeningUpload(openingFileId, model) {
  if (openingFileId === null) {
    return false;
  } else {
    return openingFileId === model.key;
  }
}



// WEBPACK FOOTER //
// ./src/js/requirements/utils/index.js